module.exports = __webpack_public_path__ + "static/basic-flow_4-b185b81a643afa54f77f9d1628eb7a98.png";